class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.initGrid();
    this.init();
    this.page = 1;
  }
 
  init() {
    const observer = new IntersectionObserver(this.revealItem.bind(this), {
      root: null,
      threshold: 1,
    });
    observer.observe(this);
  }
 
  initGrid() {
    const gridOptions = ["#product-grid", ".collection-list"];
    for (let gridName of gridOptions) {
      let grid = document.querySelector(gridName);
      if (grid) {
        this.gridName = gridName;
        this.gridContainer = grid;
        break;
      }
    }
  }

  fetchNextPage(e) {
  if (e <= this.dataset.pageSize) {
    fetch(this.dataset.next, {
      method: "GET",
      headers: { "Content-Type": "text/html" }
    })
      .then((response) => response.text())
      .then((data) => {
        const t = new DOMParser().parseFromString(data, "text/html");
        const i = t.querySelector(this.gridName).innerHTML;
        this.gridContainer.insertAdjacentHTML("beforeend", i);

        const nextButton = t.querySelector('infinite-scroll');
        if (nextButton && nextButton.dataset.next) {
          this.dataset.next = nextButton.dataset.next;
        } else {
          this.innerHTML = `<h2>${this.dataset.endText}</h2>`;
        }
      })
      .catch((e) => {
        console.error("Error:", e);
      });
  }
}
  revealItem(e, t) {
    const [i] = e;
    if (!i.isIntersecting) return;
    if (i.target) {
      this.page++;
      this.fetchNextPage(this.page);
    }
    if (this.page == this.dataset.pageSize) {
      t.unobserve(i.target);
    }
  }
}
customElements.define("infinite-scroll", InfiniteScroll);

class ViewMore extends HTMLElement {
  constructor() {
    super();
    this.initGrid();
    this.page = 2;
    this.addEventListener('click',this.loadmore);
    this.addEventListener('keydown', (e) =>{
      if (e.key === "Enter") {
        e.preventDefault();
        this.loadmore();
      }
    });
  }
  loadmore() {
    this.fetchNextPage(this.page);
    this.page++;
  }

  initGrid() {
    const gridOptions = ["#product-grid", "#collection-list"];
    for (let gridName of gridOptions) {
      let grid = document.querySelector(gridName);
      if (grid) {
        this.gridName = gridName;
        this.gridContainer = grid;
        break;
      }
    }
  }

fetchNextPage(e) {
  if (e <= this.dataset.pageSize) {
  const nextUrl = new URL(this.dataset.next, window.location.origin);

const section = this.closest('[data-section-id]');
if (section) {
  nextUrl.searchParams.set('section_id', section.dataset.sectionId);
}

fetch(nextUrl.toString(), {
  method: "GET",
  headers: { "Content-Type": "text/html" }
})
      .then((response) => response.text())
      .then((data) => {
        const t = new DOMParser().parseFromString(data, "text/html");

        const newGrid = t.querySelector(this.gridName);

        if (!newGrid) {
          console.error("No se encontró la grid filtrada");
          return;
        }

        this.gridContainer.insertAdjacentHTML("beforeend", newGrid.innerHTML);

        const nextButton = t.querySelector('view-more');
        if (nextButton && nextButton.dataset.next) {
          this.dataset.next = nextButton.dataset.next;
        } else {
          this.innerHTML = `<h2>${this.dataset.endText}</h2>`;
        }
      })
      .catch((e) => {
        console.error("Error:", e);
      });
  }
}
}
customElements.define("view-more", ViewMore);